import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { publishDiscovery } from 'action/discovery'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'
import { startCase } from 'lodash'
import { Button } from 'antd'
import styles from './styles'

const generateModalText = (title, publishText) => ({
  decide: {
    content: '',
    title: `Are you sure you want to ${publishText} ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully ${publishText}ed`
    },
    title: {
      error: `There has been an issue ${publishText}ing ${title}`,
      success: `Discovery ${publishText}ed`
    }
  }
})

const PublishDiscovery = ({ publishDiscovery, discovery: { uuid, title, published: isPublished, is_draft: isDraft }, pagination }) => {
  const publishText = isPublished ? 'unpublish' : 'publish'

  const handleSubmit = () => publishDiscovery(uuid)

  const { decide, outcome } = generateModalText(title, publishText)

  return (
    <Button
      className={styles.menu_item}
      disabled={isDraft}
      onClick={() => confirmModal(handleSubmit, decide, outcome)}
      type='text'
    >{`${startCase(publishText)} Discovery`}</Button>
  )
}

PublishDiscovery.propTypes = {
  discovery: PropTypes.object,
  pagination: PropTypes.object,
  publishDiscovery: PropTypes.func
}

const mapDispatchToProps = (dispatch) => ({
  publishDiscovery: bindActionCreators(publishDiscovery, dispatch)
})

const mapStateToProps = (state) => ({
  pagination: state.discovery.pagination
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishDiscovery)
